<template>
  <div>
    <Chart
      v-if="!isFirstLoad && !error && !isNoData"
      :options="chartOptions"
    />
    <div v-else-if="isFirstLoad" class="sk-three-bounce">
      <div class="sk-child sk-bounce1"></div>
      <div class="sk-child sk-bounce2"></div>
      <div class="sk-child sk-bounce3"></div>
    </div>
    <NoData v-else-if="isNoData"/>
    <ChartError v-else></ChartError>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from "vuex";
  import {Chart} from "highcharts-vue";
  import {HIGHCHARTS_DEFAULTS} from "../../constants";
  import ChartError from "../errors/ChartError";
  import NoData from "../errors/NoData";
  import Highcharts from 'highcharts';

  export default {
    name: "Utilisation",
    components: {
      ChartError,
      NoData,
      Chart
    },
    props: ['sitecode', 'loading', 'error', 'lastUpdatedAt'],
    methods: {
      ...mapActions(['fetchDeviceUtilisationChart', 'setFilter']),
      pieColors() {
        let colors = [];

        for (let i = 0; i < 10; i++) {
          colors.push(Highcharts.color(this.chartOptions.colors[0]).brighten((i-1) / 9).get());
        }
      this.chartOptions.colors = colors;
      }
    },
    mounted() {
      this.fetchDeviceUtilisationChart({sitecode: this.sitecode});
    },
    watch: {
      filters: {
        handler: function (value, oldVal) {
          this.fetchDeviceUtilisationChart({sitecode: this.sitecode});
        },
        deep: true,
      },
      sitecode: function (value) {
        this.fetchDeviceUtilisationChart({sitecode: value});
      },
    },
    computed: {
      ...mapGetters(["devicesByUtilisationSeries"]),
      ...mapState({filters: state => state.api.filters}),
      isFirstLoad() {
        this.pieColors();
        return this.loading && this.lastUpdatedAt == null;
      },
      isNoData() {
        const data = this.devicesByUtilisationSeries;
        if (Array.isArray(data) && data.length > 0) {
          return false;
        }
        return true;
      },
      chartOptions: function () {
        return Object.assign({}, HIGHCHARTS_DEFAULTS, {
          colors: [
            "#041E42",
            "#1D428A",
            "#407EC9",
            "#6BACE4",
            "#CE0037",
          ],
          chart: {
            type: "pie",
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            events: {},
            marginTop: 100,
            marginBottom: 0
          },
          drilldown: {
            activeDataLabelStyle: {
              color: "#ffffff"
            }
          },
          title: {
            text: "Last Seen (Days Ago)",
            style: {
              color: '#041E42',
            },
            y: 22,
            x: 15,
          },
          legend: {
            layout: 'vertical',
            align: "center",
            verticalAlign: "bottom",
            itemMarginTop: 5,
            itemMarginBottom: 5,
            symbolHeight: 8,
            symbolWidth: 15,
            symbolRadius: 3,
            symbolPadding: 1,
            margin: 5,
            itemStyle: {
              color: "#333333",
              fontWeight: "normal",
              fontSize: "10px"
            },
            labelFormatter: function () {
              return this.name + ' <b>(' + this.y + ')</b>';
            }
          },
          series: [
            {
              innerSize: "56%",
              name: "Number of devices",
              data: this.devicesByUtilisationSeries
            }
          ],
          plotOptions: {
            pie: {
              // size: "70%",
              showInLegend: true,
              dataLabels: {
                enabled: true,
                style: {
                  fontWeight: "bold",
                  fontSize: 11,
                  textOutline: 0
                },
                // format: `
                // <b>{point.name}</b>
                // <br />
                // <p>
                //   {point.percentage:.1f}%
                // </p>`,
                format: "{point.percentage:.1f}%",
                distance: -30,
                filter: {
                  property: "percentage",
                  operator: ">",
                  value: 1
                }
              },
              startAngle: -90,
              endAngle: 90,
              size: "115%"
            },
          },
          navigation: {
            buttonOptions: {
              y: 8
            }
          },
        });
      }
    },
  };
</script>

<style scoped>
</style>
